'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _constants = require('redux-router/lib/constants');

var _getDataDependencies = require('../../helpers/getDataDependencies');

var _getDataDependencies2 = _interopRequireDefault(_getDataDependencies);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint no-console: 0 */
var locationsAreEqual = function locationsAreEqual(locA, locB) {
  return locA.pathname === locB.pathname && locA.search === locB.search;
};

exports.default = function (_ref) {
  var getState = _ref.getState,
      dispatch = _ref.dispatch;
  return function (next) {
    return function (action) {
      if (action.type === _constants.ROUTER_DID_CHANGE) {
        if (getState().router && locationsAreEqual(action.payload.location, getState().router.location)) {
          return next(action);
        }

        var _action$payload = action.payload,
            components = _action$payload.components,
            location = _action$payload.location,
            params = _action$payload.params;

        var promise = new _promise2.default(function (resolve) {
          var doTransition = function doTransition() {
            next(action);
            _promise2.default.all((0, _getDataDependencies2.default)(components, getState, dispatch, location, params, true)).then(resolve).catch(function (error) {
              // TODO: You may want to handle errors for fetchDataDeferred here
              console.warn('Warning: Error in fetchDataDeferred', error);
              return resolve();
            });
            if (location.action !== 'POP') {
              setTimeout(function () {
                window.scrollTo(0, 0);
              });
            }
          };

          _promise2.default.all((0, _getDataDependencies2.default)(components, getState, dispatch, location, params)).then(doTransition).catch(function (error) {
            // TODO: You may want to handle errors for fetchData here
            console.warn('Warning: Error in fetchData', error);
            return doTransition();
          });
        });

        if (__SERVER__) {
          // router state is null until ReduxRouter is created so we can use this to store
          // our promise to let the server know when it can render
          getState().router = promise;
        }

        return promise;
      }

      return next(action);
    };
  };
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/middleware/transitionMiddleware.js
// module id = 1200
// module chunks = 0